export default __webpack_public_path__ + "static/media/emailicon.29927906.svg";